import { AccessInheritanceAwareCommand, AddToCollectionRequest } from '@/drive/entities/DriveDestinationCommand';
import { DriveItem, ProductItem } from '@/drive/entities/DriveItem/DriveItem';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { toAccessInheritanceSubject } from '@/drive/helpers/toAccessInheritanceSubject';
import { AccessInheritanceSubject } from '@/drive/types/AccessInheritanceSubject';

export class CopyDriveItemCommand implements AccessInheritanceAwareCommand {
  readonly collectionRequest: Nullable<AddToCollectionRequest>;

  constructor(readonly driveItem: DriveItem) {
    this.collectionRequest = CopyDriveItemCommand.getAddToCollectionRequest(driveItem);
  }

  get driveItemId(): DriveItemId {
    return this.driveItem.id;
  }

  async getAccessSubjects(): Promise<AccessInheritanceSubject[]> {
    const subject = toAccessInheritanceSubject(this.driveItem);

    return subject ? [subject] : [];
  }

  private static getAddToCollectionRequest(driveItem: DriveItem): Nullable<AddToCollectionRequest> {
    if (!(driveItem instanceof ProductItem) || !driveItem.productType || !driveItem.productId) {
      return null;
    }

    return { productType: driveItem.productType, productIds: [driveItem.productId] };
  }
}
